import PropTypes from 'prop-types';

import { CardActionArea, Tooltip } from '@mui/material';
import { MIcon } from '../../../@material-extend';

const IconCollapse = ({ onToggleCollapse, collapseClick }) => {
  const styleCardActionArea = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    p: 0,
    color: 'text.primary',
    borderRadius: '50%',
    cursor: 'pointer',
    bgcolor: 'background.paper',
    border: (theme) => `1px solid ${theme.palette.grey[400]}`,
    boxShadow: '0px 1px 2px 0px rgba(30, 54, 97, 0.08), 0px 2px 6px 0px rgba(30, 54, 97, 0.08)'
  };

  return (
    <Tooltip title={collapseClick ? 'Maximiser' : 'Minimiser'}>
      <CardActionArea sx={styleCardActionArea} onClick={onToggleCollapse}>
        <MIcon icon="chevron_right" sx={{ fontSize: 18, transform: `rotate(${collapseClick ? '0deg' : '180deg'})` }} />
      </CardActionArea>
    </Tooltip>
  );
};

IconCollapse.propTypes = {
  collapseClick: PropTypes.bool,
  onToggleCollapse: PropTypes.func
};

export default IconCollapse;
